export default () => {
  var event = new Event('ls:change');
  document.dispatchEvent(event);
}